import React from "react";
import { Helmet } from "react-helmet";

export const SITE_URL = "https://www.jabuzwane.co.za";
export const DEFAULT_SHARE_IMAGE = `${SITE_URL}/lg.png`;

export function plainText(value = "") {
	return value.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}

export function makeDescription(description, fallback = "") {
	const text = plainText(description || fallback);
	if (text.length <= 160) return text;
	return `${text.slice(0, 157).trimEnd()}...`;
}

const SeoMeta = ({
	title,
	description,
	path = "/",
	image = DEFAULT_SHARE_IMAGE,
	type = "website",
	keywords,
	noindex = false,
	structuredData,
}) => {
	const canonical = `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
	const safeImage = image || DEFAULT_SHARE_IMAGE;

	return (
		<Helmet>
			<title>{title}</title>
			{description && <meta name="description" content={description} />}
			{keywords?.length > 0 && <meta name="keywords" content={keywords.join(", ")} />}
			<meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
			<link rel="canonical" href={canonical} />
			<meta property="og:type" content={type} />
			<meta property="og:site_name" content="Jabu Zwane" />
			<meta property="og:title" content={title} />
			{description && <meta property="og:description" content={description} />}
			<meta property="og:url" content={canonical} />
			<meta property="og:image" content={safeImage} />
			<meta property="og:image:alt" content={title} />
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={title} />
			{description && <meta name="twitter:description" content={description} />}
			<meta name="twitter:image" content={safeImage} />
			{structuredData && (
				<script type="application/ld+json">{JSON.stringify(structuredData)}</script>
			)}
		</Helmet>
	);
};

export default SeoMeta;
